export default __webpack_public_path__ + "static/media/co-working-popup.51042c0f.png";